import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Alert, Box, Container, Link, Paper, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import DownloadBox from './DownloadBox'

import { ReactComponent as Support } from '../../../assets/icons/support.svg'
import { ReactComponent as WarningCircle } from '../../../assets/icons/warning-circle.svg'

import useStyles from './styles'

import Loader from '../Loader'

const openPrintManualPdf = async () => {
  // NOTE: solución temporal. En el futuro, el PDF será alojado en un servidor
  // o será accesible vía API.
  const document = await fetch(
    process.env.PUBLIC_URL +
      '/documents/Manual usuario digital Configuración impresión.pdf',
  )
  const blob = await document.blob()
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank')
}

const DownloadInstallJSPMApp = ({ data }) => {
  const t = useTranslations()
  const classes = useStyles()

  const {
    isLoadingFiles,
    operatingSystem,
    softwareLicenseAgreementUrl,
    otherVersionUrl,
    recommendedVersion,
    installationInstructions,
  } = data

  return (
    <>
      <Typography variant="h1" className={clsx('mainTitle', classes.mainTitle)}>
        {t('download-install-jspm-app:title')}
      </Typography>
      <Typography variant="body1" className={classes.explanation}>
        {t('download-install-jspm-app:explanation')}
      </Typography>
      <Paper elevation={1} className={classes.paper}>
        <Container className={classes.mainContainer}>
          {isLoadingFiles ? (
            <Loader />
          ) : (
            <>
              <Alert
                severity="info"
                icon={<WarningCircle />}
                className={classes.alertLicense}
              >
                <Typography variant="h4" component="p">
                  {t('download-install-jspm-app:alert-license-title')}
                </Typography>
                <Typography variant="body2" component="p">
                  {t('download-install-jspm-app:alert-license-content', {
                    link: text => (
                      <Link
                        href={softwareLicenseAgreementUrl}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.alertLink}
                      >
                        <strong>{text}</strong>
                      </Link>
                    ),
                  })}
                </Typography>
              </Alert>
              <Typography
                variant="h2"
                className={clsx(
                  'secondaryTitle',
                  'decorator',
                  classes.subtitle,
                )}
              >
                {t('download-install-jspm-app:recommended-version')}
              </Typography>
              <Typography variant="body1" className={classes.helperText}>
                {t('download-install-jspm-app:helper-text-instructions', {
                  link: text => (
                    <Link
                      href={recommendedVersion.url}
                      className={classes.alertLink}
                    >
                      {text}
                    </Link>
                  ),
                })}
              </Typography>
            </>
          )}

          {operatingSystem === undefined && !isLoadingFiles ? (
            <>
              <Alert
                severity="warning"
                className={classes.alertNotRecommendedVersion}
              >
                <Typography variant="body2">
                  {t(
                    'download-install-jspm-app:alert-recommended-version-not-obtained-content',
                    {
                      link: text => (
                        <Link
                          href="https://www.neodynamic.com/downloads/jspm/"
                          target="_blank"
                          rel="noreferrer"
                          className={classes.alertLink}
                        >
                          <strong>{text}</strong>
                        </Link>
                      ),
                    },
                  )}
                </Typography>
              </Alert>
            </>
          ) : operatingSystem && !isLoadingFiles ? (
            <>
              <DownloadBox
                infoText={recommendedVersion.text}
                mbSize={recommendedVersion.size}
                buttonText={t('action:download')}
                buttonUrl={recommendedVersion.url}
              />

              <Typography
                variant="body2"
                component="p"
                className={classes.otherVersion}
              >
                {t('download-install-jspm-app:other-version', {
                  link: text => (
                    <Link
                      href={otherVersionUrl}
                      target="_blank"
                      rel="noreferrer"
                      className={classes.otherVersionLink}
                    >
                      <strong>{text}</strong>
                    </Link>
                  ),
                })}
              </Typography>

              {/* <Typography
                variant="h2"
                className={clsx(
                  'secondaryTitle',
                  'decorator',
                  classes.subtitle,
                )}
              >
                {t('download-install-jspm-app:installation-instructions')}
              </Typography>

              <DownloadBox
                infoText={installationInstructions.text}
                buttonText={t('action:download-pdf')}
                // buttonUrl={installationInstructions.url}
                buttonUrl={null}
                mbSize={null}
              /> */}
            </>
          ) : null}
        </Container>
        <Box className={classes.footerWrapper}>
          <Container className={classes.footer}>
            <Typography
              variant="h2"
              className={clsx('secondaryTitle', 'decorator', classes.subtitle)}
            >
              {t('print-settings:problems-installing-the-app')}
            </Typography>
            <Typography variant="body1" className={classes.weHelpYouText}>
              {t('print-settings:download-print-manual')}
              <Link
                component="button"
                variant="body1"
                onClick={openPrintManualPdf}
              >
                {t('print-settings:link-text')}
              </Link>
            </Typography>

            <Typography variant="body1" className={classes.weHelpYouText}>
              {t('print-settings:we-help-you')}
            </Typography>

            <Link
              className={classes.supportLink}
              href={`mailto:${t('print-settings:support-link')}`}
            >
              <Support /> {t('print-settings:support-link')}
            </Link>
          </Container>
        </Box>
      </Paper>
    </>
  )
}

DownloadInstallJSPMApp.propTypes = {
  data: PropTypes.shape({
    isLoadingFiles: PropTypes.bool,
    operatingSystem: PropTypes.string,
    softwareLicenseAgreementUrl: PropTypes.string,
    recommendedVersion: PropTypes.shape({
      text: PropTypes.string,
      size: PropTypes.number,
      url: PropTypes.string,
    }),
    otherVersionUrl: PropTypes.string,
    installationInstructions: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
}

export default DownloadInstallJSPMApp
